import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BankNameField: React.FC = () => {
    const wireBankName = useBrokerDetailsStore((s) => s.wireBankName);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.WireBankName);

    return (
        <>
            <TextBox
                id='wireBankName'
                value={wireBankName}
                onChange={(v) => updateFields({ wireBankName: v })}
                label='Bank Name'
                width={'100%'}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon='asterisk'
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
